<template>
  <div v-if="body_show">
    <public-header :capacity="'capacity'"></public-header>
    <div class="list_main" style="margin-top:0">
      <h1>学习进度 <span>{{data.ratio}}%</span></h1>
      <div class="main_ratio">
        <div class="ratio">
          <span :style="{width: data.ratio+ '%'}"></span>
        </div>
        <div class="ra_text">
          <div class="ra_l">
            当前关卡: <span class="current-level text-ellipsis">
              <span v-if="now.levelname">{{now.levelname +'&nbsp;'+ now.name}}</span>
              <span v-else>恭喜您闯关完成</span>
            </span>
          </div>
          <div class="ra_r">
            <!-- 内容类型 1测评 2音频 3任务 4小组讨论 5案例 -->
            <a :href="now.link" v-if="now.type==1">继续闯关</a>
            <router-link v-else-if="now.type==2" :to="'/course_content?cid=' + now.cid + '&cpid=' + now.cpid + '&id=' + now.table_id">继续闯关</router-link>
            <router-link v-else-if="now.type==3" :to="now.link + '?cid=' + now.cid + '&pid=' + now.cpid + '&id=' + now.table_id">继续闯关</router-link>
            <router-link v-else-if="now.type==5" :to="{
                path: '/case_analysis',
                query: {
                  'id': now.id,
                  'cid':now.cid
                }
              }">继续闯关</router-link>
            <a v-else>完成闯关</a>
          </div>
        </div>
      </div>
    </div>
    <div class="list_main" v-for="(item,index) in project_list" :key="index">
      <h2 class="main_h2">{{item.name}} <span>({{item.starttime}} 解锁)</span></h2>
      <div class="list_level" v-for="(itm,idx) in item.list" :key="idx">
        <h3>
          <span :title="itm.level_name" class="h3-title text-ellipsis">{{itm.level_name}}</span>
          <span v-if="itm.level_list[0].unlock" @click="LevelHandle(itm)"   class="introduce">关卡介绍</span>
          <span v-else class="introduce  on">关卡介绍</span>
        </h3>
        <ul>
          <li v-for="(it,ix) in itm.level_list" :key="ix" :class="it.unlock?(it.complete?'states_complete':''):'states_unlock'">
            <!-- 内容类型 1测评 2音频 3任务 4小组讨论 5案例 -->
            <a href="JavaScript:;" @click="list_link(it,itm.level_name)">
              <i v-if="it.type==1">
                <img src="@a/cl_cp1.png" alt="" v-if="!it.unlock"/>
                <i v-else>
                  <img src="@a/cl_cp2.png" alt="" v-if="it.complete"/>
                  <img src="@a/cl_cp3.png" alt="" v-else/>
                </i>
              </i>
              <i v-if="it.type==2">
                <img src="@a/cl_ck1.png" alt="" v-if="!it.unlock"/>
                <i v-else>
                  <img src="@a/cl_ck2.png" alt="" v-if="it.complete"/>
                  <img src="@a/cl_ck3.png" alt="" v-else/>
                </i>
              </i>
              <i v-if="it.type==3">
                <img src="@a/cl_rw1.png" alt="" v-if="!it.unlock"/>
                <i v-else>
                  <img src="@a/cl_rw2.png" alt="" v-if="it.complete"/>
                  <img src="@a/cl_rw3.png" alt="" v-else/>
                </i>
              </i>
              <i v-if="it.type==5">
                <img src="@a/cl_al1.png" alt="" v-if="!it.unlock"/>
                <i v-else>
                  <img src="@a/cl_al2.png" alt="" v-if="it.complete"/>
                  <img src="@a/cl_al3.png" alt="" v-else/>
                </i>
              </i>
              {{it.name}}
              <span v-if="!it.unlock">
                <img src="@a/complete1.png" alt="" class="lock"  />
              </span>
              <span v-else>
                <img src="@a/complete2.png" alt="" class="lock" v-if="it.complete"/>
                <img src="@a/complete3.png" alt="" class="lock" v-else/>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 未完成案例分析弹出 -->
    <van-popup v-model="complete_show">
      <div class="complete">
        <h2>哇，你都会抢答了<br/>还是听完课程再来答题吧!</h2>
        <a @click="complete_show=false">回去听完</a>
      </div>
    </van-popup>
    <!-- 关卡介绍 -->
    <van-popup class="Level-pop" v-model="LevelShow">
      <div class="Level-gorup">
        <h2>{{levelObj.level_name}}</h2>
        <p v-html="html(levelObj.level_des)"></p>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getproject,coursedetail} from "@/api/course";
import { project_click_time} from "@/api/course"
import { statistics} from "@/api/public";
import { statistic_next} from "@/api/course"
import { shareCon} from "@/utils/wxconfig";
import { getStorage, setStorage} from "@/utils/tools"
export default {
  props: {
    pulldata: Object
  },
  data() {
    return {
      cid: null,
      data: {},
      body_show: false,
      project_list: [],
      now: {},
      footer_show: true,
      routArg: {},
      assistant_show: false,
      complete_show: false,
      //关卡介绍
      LevelShow:false,
      levelObj:{}
    }
  },
  computed:{
    html(){
      return (val)=>{
        return val?val.replace(/\n/g,"<br/>").replace(/ /g,"&nbsp;"):'';
      }
    }
  },
  methods: {
    /*
     *@param: level_des 关卡介绍
     *@Description: 点击关卡介绍按钮触发
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-03 11:56:35
    */
    LevelHandle(item){
      if(item.level_des){
        this.levelObj = item;
        this.LevelShow = true;
      }else{
        this.$toast('暂无关卡介绍！');
      }
      
    },
    /*
     *@param: item,title
     *@Description: 内容类型 1测评 2音频 3任务 4小组讨论 5案例
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-28 11:56:00
    */
    list_link(item,title) {
      if (item.unlock) {
        if (item.type == 1) {
          if(item.link.startsWith('http')){
            window.location.href = item.link+'?level_list_id=' + item.id;
          }else{
            this.$router.push({
              path:item.link,
              query:{
                level_list_id:item.id
              }
            })
          }
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid +'&level_list_id=' + item.id+ '&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          // 是否完成当前任务，已完成跳转报告页面
          if(item.complete){
            this.$router.push('project_report?cid=' + item.cid +'&level_list_id=' + item.id+ '&cpid=' + item.cpid + '&taskid=' + item.table_id)
          }else{
            this.$router.push(item.link + '?cid=' + item.cid + '&level_list_id=' + item.id+ '&pid=' + item.cpid + '&id=' + item.table_id+'&name=' + title)
          }
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id+'&level_list_id=' + item.id+ '&cid=' + item.cid)
        }
      } else {
        if (item.type == 5) {
          this.complete_show = true;
        }
      }
    },
    pullData(data) {
      let querys = this.$route.query;
      this.cid = querys.cid;
      this.body_show = true;
      this.data = data;
      this.project_list = data.project;
      this.now = data.now;
    },
  },
  created() {
    this.pullData(this.pulldata);
    shareCon("course", this);
  }
}
</script>
<style lang="scss">
body{
  background: #f0f0f0;
}
</style>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.list_main {
  width: 100%;
  padding: 30px;
  background-color: #fff;
  margin-top: 20px;
  h1 {
    font-size: 34px;
    color: #333;
    font-weight: bold;
    span {
      color: #EB5032;
    }
  }
  .main_ratio {
    margin-top: 20px;
    .ratio {
      width: 100%;
      height: auto;
      padding: 4px;
      background-color: #F0F0F0;
      border-radius: 10px;
      span {
        background: linear-gradient(-90deg, rgba(245, 127, 23, 1), rgba(235, 80, 50, 1));
        border-radius: 6px;
        height: 12px;
        width: auto;
        display: block;
        text-align: left;
      }
    }
    .ra_text {
      display: flex;
      margin-top: 20px;
      align-items: center;
      .ra_l {
        margin-right: auto;
        font-size: 26px;
        color: #333;
        display: flex;
        span.current-level{
          display: block;
          width: 400px;
          color: #EB5032;
          margin-right: auto;
          margin-left: 8px;
        }
      }
      .ra_r {
        width: 152px;
        height: 54px;
        background: rgba(235, 80, 50, 1);
        border-radius: 27px;
        line-height: 54px;
        color: #fff;
        font-size: 26px;
        text-align: center;
        a {
          display: block;
          width: 100%;
          height: 100%;
          color: #fff;
        }
      }
    }
  }
  h2.main_h2 {
    font-size: 34px;
    color: #333333;
    font-weight: bold;
    span {
      font-weight: normal;
      font-size: 24px;
    }
  }
  .list_level {
    padding: 50px 0;
    border-bottom: 1px solid #ccc;
    h3{
      font-size: 28px;
      color: #333;
      font-weight: bold;
      display: flex;
      align-items: center;
      .h3-title{
        display: block;
        width: 500px;
      }
      .introduce{
        margin-left: auto;
        font-size: 24px;
        color: #F57F17;
        text-decoration: underline;
      }
      .introduce.on{
        color: #999999;
      }
    }
    ul {
      li {
        a {
          font-size: 26px;
          width: 100%;
          padding: 25px 28px;
          background: rgba(245, 127, 23, 1);
          border-radius: 50px;
          margin-top: 20px;
          color: #fff;
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
          img {
            width: 50px;
            margin-right: 32px;
          }
          span {
            margin-left: auto;
            img.lock {
              margin-right: 0;
              width: 60px;
            }
          }
        }
      }
      .states_unlock a {
        background-color: #F0F0F0;
        color: #999;
      }
      .states_complete a {
        background-color: #FEF2E7;
        color: #333;
      }
    }
  }
  .list_level:last-child {
    border-bottom: none;
  }
}

.complete {
  width: 480px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  text-align: center;
  padding-top: 50px;
  h2 {
    font-size: 34px;
    color: #333;
    line-height: 50px;
  }
  a {
    line-height: 100px;
    width: 100%;
    border-top: 1px solid #ccc;
    font-size: 34px;
    color: #EB5032;
    display: block;
    margin-top: 48px;
  }
}
// 关卡介绍
.Level-pop{
  background-color: transparent;
}
.Level-gorup{
  background-color: #fff;
  width: 600px;
  padding: 90px 46px;
  box-sizing: border-box;
  border-radius:8px;
  h2{
    color: #F57F17;
    font-weight: 500;
    text-align: center;
    margin-bottom: 40px;
  }
  p{
    font-size: 26px;
    color: #333333;
    line-height: 40px;
  }
}
</style>
